<template>
<BarChart :chartData="chartDatasets" :options="chartOptions" :height="chartHeight" :width="chartWidth" />
</template>

<script>
import { BarChart } from 'vue-chart-3';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels'

Chart.register(...registerables, ChartDataLabels);

export default {
    name: 'ChartsClosed',
    components: { BarChart },
    props: {
        dataSet: {
            type: Object,
            default() {
                return {};
            }
        },
    },
    data() {
        return {
            chartDatasets: {
                labels: [],
                datasets: [
                    {
                        label: 'Новые лоты',
                        data: [],
                        backgroundColor: '#82bf00', borderRadius: {
                            topLeft: 2,
                            topRight: 2,
                        },
                        barPercentage: 0.8,
                        quantity_dynamics: [],
                    },
                    {
                        label: 'Закрытые лоты',
                        data: [],
                        backgroundColor: '#c8c8cb',
                        borderRadius: {
                            bottomLeft: 2,
                            bottomRight: 2,
                        },
                        barPercentage: 0.8,
                        quantity_dynamics: [],
                    },
                ]
            },
            chartOptions: {
                animations: false,
                onHover: (event, chartElement) => {
                    event.native.target.style.cursor = 'pointer';
                },
                plugins: {
                    tooltip: {
                        enabled: false,
                        external: function (context) {
                            let tooltipEl = document.getElementById('chartjs-tooltip');
                            const tooltipModel = context.tooltip;
                            if (tooltipModel.opacity === 0) {
                                closePopup();
                                return;
                            }
                            tooltipEl.style.opacity = 1
                            tooltipEl.style.visibility = 'visible'


                            // Добавляем обработчик события для отслеживания перемещения указателя мыши
                            document.addEventListener('mousemove', (event) => {
                                setCoord(event)
                            });

                            function setCoord(event) {
                                const x = event.clientX;
                                const y = event.clientY;

                                // Позиционируем окно относительно координат указателя мыши
                                if (document.documentElement.clientWidth >= 650) {
                                    tooltipEl.style.left = `${x + 10}px`;
                                    tooltipEl.style.top = `${y + 10}px`;
                                    if (tooltipModel.caretX > tooltipEl.offsetWidth ? tooltipEl.offsetWidth : 0) {
                                        tooltipEl.style.left = `${x - 10 - tooltipEl.offsetWidth}px`;
                                    }
                                }
                            }

                            function closePopup() {
                                tooltipEl.style.opacity = 0;
                                tooltipEl.style.visibility = 'hidden';
                                tooltipEl.style.removeProperty('width');
                                tooltipEl.style.removeProperty('bottom');
                                document.body.classList.remove('body-lock-scroll');
                                document.removeEventListener('mousemove', setCoord)
                                document.removeEventListener('click', closePopup)
                                document.removeEventListener('scroll', hideOnscroll)
                            }

                            function hideOnscroll() {
                                closePopup();
                                if (document.documentElement.clientWidth >= 650) {
                                    let innerWidth = window.innerWidth;
                                    let documentWidth = document.documentElement.clientWidth
                                    if (innerWidth === documentWidth) {
                                    }
                                }
                            }

                            // цвет текста в зависимости от значения
                            function getColor(val) {
                                if (Number(val) > 0) {
                                    return 'color:#699b12;';
                                } else if (Number(val) < 0) {
                                    return 'color:#de4a2a;';
                                } else return 'color:#6D6D6D;';
                            }

                            if (tooltipModel.body) {
                                let innerHtml
                                let title = tooltipModel.title[0].split(',').join(' ')
                                let quantity = tooltipModel._tooltipItems[0]?.formattedValue
                                let name = tooltipModel.dataPoints[0].dataset.label;
                                let quantity_dynamic = tooltipModel.dataPoints[0].dataset.quantity_dynamics[tooltipModel.dataPoints[0].dataIndex]

                                if (document.documentElement.clientWidth >= 650) {
                                    innerHtml = '<p class="bar" style="border-radius: 4px; font-family: Gilroy-Medium, sans-serif;width: max-content; background: ' + tooltipModel.labelColors[0].backgroundColor + '; padding: 1px 6px; margin-bottom: 8px; font-size: 12px; line-height: 16px">' + title + '</p>' + '<p style=" margin-bottom: 6px; font-size: 14px; line-height: 20px; font-family: Gilroy-SemiBold, sans-serif;">' + name + '</p>' + '<div style="margin-bottom: 9px; display: flex; justify-content: space-between; align-items: flex-end">' +
                                        '<p style="max-width: 165px;  font-size: 12px; line-height: 16px; font-family: Gilroy-Medium, sans-serif;">' +
                                        'Количество объявлений'
                                        + '</p> <p style="max-width: 117px; font-family: Gilroy-SemiBold, sans-serif; font-size: 16px; line-height: 24px;">' + Math.abs(quantity) + ' тыс.шт</p></div>' + '<div style="display: flex; justify-content: space-between; align-items: flex-start"><p style="color:#6D6D6D;font-family: Gilroy-Medium, sans-serif; font-size: 12px; line-height: 16px;max-width: 165px;  font-size: 12px; line-height: 16px;">' +
                                        'Изменение к предыдущему кварталу'
                                        + `</p> <p style="max-width: 117px; font-family: Gilroy-Medium, sans-serif;  font-size: 16px; line-height: 24px; ${getColor(quantity_dynamic)}" >${quantity_dynamic}%</p></div>`
                                    tooltipEl.innerHTML = innerHtml
                                } else {
                                    innerHtml = '<div class="chartjs-popup-mobile-close"><div class="chartjs-popup-mobile-close-title">Динамика новых и закрытых объявлений о сдаче квартир в России<button class="chartjs-popup__button-close"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">\n' +
                                        '<rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#252628"/>\n' +
                                        '<path fill-rule="evenodd" clip-rule="evenodd" d="M11.2092 11.2092C11.4882 10.9303 11.9404 10.9303 12.2194 11.2092L16 14.9898L19.7806 11.2092C20.0596 10.9303 20.5118 10.9303 20.7908 11.2092C21.0697 11.4882 21.0697 11.9404 20.7908 12.2194L17.0102 16L20.7908 19.7806C21.0697 20.0596 21.0697 20.5118 20.7908 20.7908C20.5118 21.0697 20.0596 21.0697 19.7806 20.7908L16 17.0102L12.2194 20.7908C11.9404 21.0697 11.4882 21.0697 11.2092 20.7908C10.9303 20.5118 10.9303 20.0596 11.2092 19.7806L14.9898 16L11.2092 12.2194C10.9303 11.9404 10.9303 11.4882 11.2092 11.2092Z" fill="#252628"/>\n' +
                                        '</svg></button></div>' + '<p class="bar" style="width: max-content; background: ' + tooltipModel.labelColors[0].backgroundColor + '; padding: 1px 6px; margin-bottom: 9px; font-size: 12px; line-height: 16px">' + title + '</p>' + '<h4 style=" margin-bottom: 8px; font-size: 18px; line-height: 24px">' + name + '</h4>' + '<div style="margin-bottom: 9px; display: flex; justify-content: space-between">' +
                                        '<p class="chartjs-popup-mobile-close-quantity" style="font-size: 12px; line-height: 16px;">' +
                                        'Количество <br>объявлений'
                                        + '</p> <p class="chartjs-popup-mobile-close-value" style="max-width: 117px;  font-size: 16px; line-height: 24px;">' + Math.abs(quantity) + ' тыс.шт</p></div>' + '<div style="display: flex; justify-content: space-between"><p class="chartjs-popup-mobile-close-diff" style="font-size: 12px; line-height: 16px;">' +
                                        'Изменение к <br>предыдущему кварталу'
                                        + `</p> <p class="chartjs-popup-mobile-close-value-dynamic" style="font-family: Gilroy-Medium, sans-serif;  font-size: 16px; line-height: 24px; ${getColor(quantity_dynamic)}" >${quantity_dynamic}%</p></div>`
                                    tooltipEl.innerHTML = innerHtml
                                    document.querySelector('.chartjs-popup__button-close').addEventListener('click', closePopup)
                                }
                            }

                            document.addEventListener('scroll', hideOnscroll)

                            if (document.documentElement.clientWidth <= 649) {
                                document.body.classList.add('body-lock-scroll');
                            }
                        }
                    },
                    legend: false,
                    datalabels: {
                        color: 'transparent',
                        labels: {
                            value: {
                                anchor: 'center',
                                align: 'center',
                                formatter: (value, context) => {
                                    //console.log(context.dataset.topics[context.dataIndex].quantity_percent)
                                    // if (context.dataset.topics[context.dataIndex].quantity_percent > 10) {
                                    //     return context.dataset.topics[context.dataIndex].quantity_percent + '%'
                                    // }
                                    // return Math.abs(Number(value));
                                }
                            },
                            title: {
                                formatter: (value, context) => {
                                    // if (context.datasetIndex === context.chart.data.datasets.length - 1) {
                                    //     //console.log(context.dataIndex)
                                    //     return [Object.values(context.chart.data.datasets[2].countMax)[context.dataIndex].sum_quantity, '', '']
                                    // }
                                    return Math.abs(Number(value));
                                },
                                anchor: function (item, data) {
                                    if (item.dataset.backgroundColor === '#c8c8cb') {
                                        return 'start'
                                    } else return 'end';
                                },
                                color: '#252628',
                                align: function (item, data) {
                                    if (item.dataset.backgroundColor === '#c8c8cb') {
                                        return 'start'
                                    } else return 'end';
                                },
                                font: {
                                    size: document.documentElement.clientWidth >= 767 ? 14 : 14,
                                    family: 'Gilroy-SemiBold, sans-serif'
                                }
                            }
                        }
                    },
                },
                responsive: () => {
                    return this.isMobile();
                },
                scales: {
                    x: {
                        offset: true,
                        stacked: true,
                        grid: {
                            display: false,
                            borderColor: '#999999',
                        },
                        ticks: {
                            color: '#999999',
                            font: {
                                size: 12
                            },
                            callback: (idx) => {
                                //console.log(context.dataset.topics[context.dataIndex].quantity_percent)
                                // if (context.dataset.topics[context.dataIndex].quantity_percent > 10) {
                                //     return context.dataset.topics[context.dataIndex].quantity_percent + '%'
                                // }
                                let splitArr = this.chartDatasets.labels[idx].split(' ');
                                let number = [splitArr[0] + ' ' + splitArr[1], splitArr[2]];
                                return number;
                            }
                        },
                    },
                    y: {
                        stacked: true,
                        min: () => {
                            return this.minMaxNumber('min', 1.3);
                        },
                        // max: () => {
                        //     return this.minMaxNumber('max') + 20;
                        // },
                        grid: {
                            drawBorder: true,
                            drawTicks: true,
                            display: false,
                            borderColor: '#999999'
                        },
                        title: {
                            display: false
                        },
                        ticks: {
                            color: '#999999',
                            // backdropPadding: 10,
                            // stepSize: 20,
                            padding: 10,
                            font: {
                                size: 12
                            },
                            align: 'end',
                            callback(val, index, ticks) {
                                const maxCount = Math.max.apply(null, ticks.map((a) => a.value))
                                if (val == maxCount) {
                                    return document.documentElement.clientWidth >= 767 ? ['тысяч', ' объявлений', ' '] : ['тысяч', ' объявл.']
                                } else if (val === 0) {
                                    return '';
                                } else return Math.abs(val);
                            },
                        }
                    }
                }
            }
        };
    },
    mounted() {
        let periods;
        if (document.documentElement.clientWidth <= 649) {
            periods = this.dataSet.slice(2);
        } else {
            periods = this.dataSet;
        }
        periods.forEach((el, idx) => {
            this.chartDatasets.labels[idx] = el.period;
            this.chartDatasets.datasets[0].data[idx] = el.new.quantity;
            this.chartDatasets.datasets[0].quantity_dynamics[idx] = this.formatNum(el.new.quantity_dynamics);
            this.chartDatasets.datasets[1].data[idx] = Number('-' + el.closed.quantity);
            this.chartDatasets.datasets[1].quantity_dynamics[idx] = this.formatNum(el.closed.quantity_dynamics);
        })
    },
    computed: {
        isDesktop() {
            return document.documentElement.clientWidth >= 1124;
        },
        chartHeight() {
            return (this.isDesktop) ? 586 : 586;
        },
        chartWidth() {
            return (this.isDesktop) ? 485 : 485;
        }
    },
    methods: {
        formatNum(num) {
            if (Number(num) > 0) {
                return '+' + num;
            } else {
                return num;
            }
        },
        isMobile() {
            return document.documentElement.clientWidth <= 650;
        },
        //** Функция получения мин, макс значения из массива
        //  *
        //  * @param {*} param min или max
        //  * @param {*} ratio коэфф. увеличить верхнее/нижнее значение от param
        //  */
        minMaxNumber(param, ratio = false) {
            let newArr = [];
            this.chartDatasets.datasets.forEach(el => newArr.push(...el.data));
            const numArr = newArr.map(Number);
            let p;
            param === 'min' ? p = Math.min(...numArr) : p = Math.max(...numArr);
            return ratio ? Math.ceil((p * ratio) / 10) * 10 : p;
            // const value = Math.ceil((p * ratio) / 10) * 10;
            // return value;
        },

        maxNumber() {
            let newArr = [];
            this.chartDatasets.datasets.forEach(el => newArr.push(...el.data));
            const numArr = newArr.map(Number);
            const max = Math.max(...numArr);
            const maxValue = Math.ceil((max * 1.8) / 10) * 10;
            return maxValue;
        },

        updateGraph() {
        }
    },
}
</script>